import React from 'react';
import { RawButton } from '../../../../../../CommonComponents/OPL/Button/Button.styles';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { TextLoading } from '../../../../../../CommonComponents/OPL/Text/Text.loading';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';

interface NetWorthProps {
  amount?: number;
  onClick?: () => void;
  isLoading?: boolean;
}

export const NetWorth: React.FC<NetWorthProps> = ({ amount, onClick, isLoading = false }) => {
  return (
    <Card p="32" height="100%" display="flex" flexDirection="column" justifyContent="center">
      {onClick ? (
        <RawButton onClick={onClick} css="align-self: flex-start;">
          <Text fontWeight={600} color="neutral.600" textTransform="uppercase" letterSpacing="wide">
            Net Worth <Icon className="fas fa-chevron-right" color="neutral.400" fontSize="small" />
          </Text>
        </RawButton>
      ) : (
        <Text fontWeight={600} color="neutral.600" textTransform="uppercase" letterSpacing="wide">
          Net Worth
        </Text>
      )}

      {isLoading ? (
        <TextLoading height="h2" width={180} />
      ) : (
        <Text variant="tabular" fontWeight={600} fontSize="h2">
          {amount ? formatCurrency(amount) : '–'}
        </Text>
      )}
    </Card>
  );
};
